module.exports = __webpack_public_path__ + "static/img/RS4268_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RS4268_1.png
// module id = W/7o
// module chunks = 0